import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StateService } from './services/state.service';

@Injectable({
    providedIn: 'root'
})
export class AppRoutingGuard implements CanActivate  {

    constructor(private stateSvc: StateService, private router: Router) {}
    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
        if (this.stateSvc.getLocalSession()) {
            return true;
        } else {
            return this.router.parseUrl('');
        }
    }
}